import React, { Component } from "react";
import { TextInput, View } from "react-native";
import PropTypes from "prop-types";

import colors from "@constants/color";
import Metrics, { fonts } from "@constants/metrics";
import Text from "@components/AppText";

export default function InputBox(props) {
  const [focus, setFocus] = React.useState(false);

  const {
    placeholder = "",
    password = false,
    lines = 1,
    multiline = false,
    maxLength = 50,
    error = false,
    errorMessage = "",
    keyboardType = "default",
    labelText = "",
    textBoxHeight = 56,
    icon = null,
    required = false,
    onChange = (e) => e,
    value = "",
    editable = true,
    onKeyPress = () => {},
    onSubmitEditing = () => {},
    setRef = () => {},
    labelTextColor = "#000",
    labelTextStyle = {},
    containerStyle = {},
    inputStyle = {},
    borderRadius = 4,
    bold = false,
    hideError = true,
    autoFocus = false,
    borderOnFocus = "#000",
    fontType = "head3",
    helperText = "",
    helperTextColor = "#000",
    showRupee = false,
  } = props;

  return (
    <View style={containerStyle}>
      <View
        style={{
          flex: 1,
          flexDirection: "row",
          marginBottom: labelText !== "" ? 4 : 0,
        }}
      >
        {icon && <View style={{ marginLeft: 2 }}>{icon}</View>}
        {labelText !== "" ? (
          <View style={{ marginLeft: 4, flexDirection: "row" }}>
            <Text
              fontType="head4"
              style={[
                { fontWeight: "bold", color: labelTextColor },
                labelTextStyle,
              ]}
            >
              {labelText}{" "}
            </Text>
            {required && (
              <Text style={{ color: colors.primary }} fontType="head3">
                *
              </Text>
            )}
          </View>
        ) : null}
      </View>
      <View
        style={[
          {
            justifyContent: "center",
            flexDirection: "row",
          },
          {
            borderWidth: 1,
            backgroundColor: colors.white,
            borderColor: focus
              ? borderOnFocus
              : error
                ? colors.errorRed
                : "rgba(0, 0, 0, 0.2)",
            borderRadius,
          },
        ]}
      >
        {showRupee && (
          <Text
            bold
            style={{
              paddingLeft: 10,
              fontSize: 20,
              lineHeight: 28,
              paddingTop: 7,
              marginRight: -4,
            }}
          >
            ₹
          </Text>
        )}
        <TextInput
          style={[
            {
              height: !lines ? textBoxHeight : null,
              fontSize: fonts[fontType],
              fontWeight: bold ? "bold" : "normal",
              padding: Metrics.margin4,
              // borderRadius,
              textAlignVertical: "top",
              color: colors.black,
              opacity: 0.8,
              // width: "100%",
              justifyContent: "center",
              textAlignVertical: "top",
              flex: 1,
            },
            inputStyle,
          ]}
          autoFocus={autoFocus}
          onFocus={() => {
            setFocus(true);
          }}
          onBlur={() => {
            setFocus(false);
          }}
          placeholder={placeholder}
          onChangeText={(text) => onChange(text)}
          value={value}
          secureTextEntry={password}
          numberOfLines={lines}
          multiline={multiline}
          maxLength={maxLength}
          error={error}
          keyboardType={keyboardType}
          returnKeyType="send"
          editable={editable}
          selectionColor={colors.primary}
          //^passable values^ = number-pad, decimal-pad, numeric, email-address, phone-pad
          onKeyPress={onKeyPress}
          onSubmitEditing={onSubmitEditing}
          ref={setRef}
        />
        {Boolean(helperText) && (
          <Text style={{ color: helperTextColor, paddingTop: 5 }}>
            {helperText}
          </Text>
        )}
        {hideError && (
          <View>
            {errorMessage !== "" && (
              <Text
                style={{ color: "red", marginTop: 4, opacity: error ? 1 : 0 }}
                disabled={true}
                fontType="content2"
              >
                {errorMessage}
              </Text>
            )}
          </View>
        )}
      </View>
    </View>
  );
}

InputBox.propTypes = {
  placeholder: PropTypes.string,
  password: PropTypes.string,
  lines: PropTypes.number,
  multiline: PropTypes.bool,
  maxLength: PropTypes.number,
  error: PropTypes.bool,
  errorMessage: PropTypes.string,
  keyboardType: PropTypes.string,
  labelText: PropTypes.string,
  textBoxHeight: PropTypes.number,
  icon: PropTypes.node,
  onChange: PropTypes.func,
};
